module.exports = __webpack_public_path__ + "img/own-goal-symbol.6a21d853.svg";